<template>
  <div id="app">
    <!-- 首页 -->
    <template v-if="$route.path === '/'">
      <HomeLayout>
        <router-view />
      </HomeLayout>
    </template>

    <!-- 需要登录的页面 -->
    <template v-else-if="$route.meta.requiresAuth">
      <AuthorizeLayout>
        <router-view />
      </AuthorizeLayout>
    </template>

    <!-- 普通页面 -->
    <template v-else>
      <DefaultLayout>
        <router-view />
      </DefaultLayout>
    </template>
  </div>
</template>

<script>
import DefaultLayout from '@/layouts/default.vue'
import AuthorizeLayout from '@/layouts/authorize.vue'
import HomeLayout from '@/layouts/home.vue'

export default {
  components: {
    DefaultLayout,
    AuthorizeLayout,
    HomeLayout
  }
}
</script>